import { FeedbackFormType } from '../types/FeedbackFormType';

export const initialFeedbackFormValues: FeedbackFormType = {
  lastName: '',
  firstName: '',
  patronymic: '',
  phone: '',
  email: '',
  organizationName: '',
  position: '',
  declarantType: null,
  text: '',
  topic: '',
  knmId: undefined,
  planId: undefined,
};
